<script lang="ts" module>
  // Bộ icon inline (stroke, currentColor) — tự dựng vì icon trong gói thiết kế là placeholder trùng nhau.
  // Style Lucide: viewBox 24, stroke-width 2, fill none.
  export type IconName =
    | 'rotate'
    | 'pan'
    | 'zoom'
    | 'fit'
    | 'reset'
    | 'material'
    | 'edge'
    | 'wireframe'
    | 'xray'
    | 'projection'
    | 'measure'
    | 'dimension'
    | 'share'
    | 'copy'
    | 'qr'
    | 'scan'
    | 'fullscreen'
    | 'info'
    | 'list'
    | 'expand'
    | 'collapse'
    | 'drawer'
    | 'flip'
    | 'save'
    | 'eye'
    | 'eyeOff'
    | 'hingeL'
    | 'hingeR'
    | 'lift'
    | 'slide'
    | 'check'
    | 'warning'
    | 'close'
    | 'search'
    | 'cube'
    | 'chevronDown'
    | 'chevronUp'
    | 'sun'
    | 'bulb'
    | 'sunrise'
    | 'power'
    | 'arrowLeft'
    | 'arrowRight'
    | 'wireframeHidden'
    | 'sparkles'
    | 'image'
    | 'download'
    | 'explode'
    | 'isolate'
    | 'label'
    | 'trash';

  const P: Record<IconName, string> = {
    rotate: '<path d="M21 12a9 9 0 1 1-3-6.7"/><path d="M21 3v4h-4"/>',
    pan: '<path d="M12 2v20M2 12h20M9 5l3-3 3 3M9 19l3 3 3-3M5 9l-3 3 3 3M19 9l3 3-3 3"/>',
    zoom: '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/>',
    fit: '<path d="M4 9V5a1 1 0 0 1 1-1h4M20 9V5a1 1 0 0 0-1-1h-4M4 15v4a1 1 0 0 0 1 1h4M20 15v4a1 1 0 0 1-1 1h-4"/>',
    reset: '<path d="M3 12a9 9 0 1 0 9-9 9 9 0 0 0-6.36 2.64L3 8"/><path d="M3 3v5h5"/>',
    material: '<path d="M12 2l9 5v10l-9 5-9-5V7z"/><path d="M3 7l9 5 9-5M12 12v10"/>',
    edge: '<path d="M12 2l9 5v10l-9 5-9-5V7z"/>',
    wireframe: '<path d="M12 2l9 5v10l-9 5-9-5V7z"/><path d="M3 7l9 5 9-5M12 12v10M3 17l9-5 9 5"/>',
    xray: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
    projection: '<rect x="3" y="3" width="18" height="18" rx="1"/><path d="M3 9h18M3 15h18M9 3v18M15 3v18"/>',
    measure: '<path d="M3 7l4-4 14 14-4 4z"/><path d="M7 7l2 2M11 5l2 2M9 9l2 2M13 7l2 2"/>',
    dimension: '<path d="M5 5v14M19 5v14M5 12h14"/><path d="M8 9l-3 3 3 3M16 9l3 3-3 3"/>',
    share: '<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/>',
    copy: '<rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>',
    qr: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3M21 14v3M14 21h3M21 21h.01"/>',
    fullscreen:
      '<path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/>',
    scan: '<path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2"/><path d="M3 12h18"/>',
    info: '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/>',
    list: '<path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>',
    expand: '<path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5"/>',
    collapse: '<path d="M3 8h5V3M16 3v5h5M3 16h5v5M21 16h-5v5"/>',
    drawer:
      '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18M3 15h18M10 7h4M10 12.5h4M10 18h4"/>',
    flip: '<path d="M12 3v18M7 8l-4 4 4 4M17 8l4 4-4 4"/>',
    save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><path d="M17 21v-8H7v8M7 3v5h8"/>',
    eye: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
    eyeOff: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/><path d="M3 3l18 18"/>',
    hingeL: '<rect x="4" y="3" width="3" height="18" rx="1"/><path d="M7 5l13 2v10l-13 2"/>',
    hingeR: '<rect x="17" y="3" width="3" height="18" rx="1"/><path d="M17 5L4 7v10l13 2"/>',
    lift: '<rect x="4" y="9" width="16" height="11" rx="1"/><path d="M8 9V6a4 4 0 0 1 8 0v3M12 13v3"/>',
    slide: '<path d="M2 12h20M6 8l-4 4 4 4M18 8l4 4-4 4"/>',
    check: '<path d="M20 6L9 17l-5-5"/>',
    warning: '<path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4M12 17h.01"/>',
    close: '<path d="M18 6L6 18M6 6l12 12"/>',
    search: '<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.3-4.3"/>',
    cube: '<path d="M12 2l9 5v10l-9 5-9-5V7z"/><path d="M3 7l9 5 9-5M12 12v10"/>',
    chevronDown: '<path d="M6 9l6 6 6-6"/>',
    chevronUp: '<path d="M18 15l-6-6-6 6"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>',
    bulb: '<path d="M9 18h6M10 22h4"/><path d="M15.1 14c.2-.8.7-1.4 1.3-2.1A5 5 0 1 0 7.6 11.9c.6.7 1.1 1.3 1.3 2.1"/>',
    sunrise: '<path d="M12 2v6M4.2 10.2l1.4 1.4M1 18h2M21 18h2M18.4 11.6l1.4-1.4M23 22H1M16 18a4 4 0 0 0-8 0M8 6l4-4 4 4"/>',
    power: '<path d="M12 2v10M18.4 6.6a9 9 0 1 1-12.8 0"/>',
    arrowLeft: '<path d="M19 12H5M12 19l-7-7 7-7"/>',
    arrowRight: '<path d="M5 12h14M12 5l7 7-7 7"/>',
    // ô trước nét liền (nhìn thấy) + ô sau nét đứt (khuất)
    wireframeHidden: '<path d="M3 8h10v10H3z"/><path d="M9 5h12v11" stroke-dasharray="2.5 2"/><path d="M13 16h8" stroke-dasharray="2.5 2"/>',
    sparkles: '<path d="M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9z"/><path d="M19 14l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/>',
    image: '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>',
    download: '<path d="M12 3v12M7 10l5 5 5-5"/><path d="M5 21h14"/>',
    // ô trung tâm + 4 mũi tên toả chéo ra góc = "tách rời" (exploded view)
    explode: '<rect x="9" y="9" width="6" height="6" rx="1"/><path d="M8 8L3.5 3.5M16 8l4.5-4.5M8 16l-4.5 4.5M16 16l4.5 4.5"/><path d="M3.5 7.5V3.5H7.5M16.5 3.5h4V7.5M3.5 16.5v4h4M16.5 20.5h4v-4"/>',
    // khung focus 4 góc + ô ĐẶC ở giữa = "chỉ giữ cái này, ẩn phần còn lại" (isolate / hide others)
    isolate: '<path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3"/><rect x="9" y="9" width="6" height="6" rx="1" fill="currentColor"/>',
    // thẻ nhãn + chấm leader = "nhãn tên chi tiết" (sơ đồ lắp đặt)
    label: '<path d="M3 6a2 2 0 0 1 2-2h7l8 8-7 7-8-8V6z"/><circle cx="7.5" cy="7.5" r="1.5"/>',
    trash: '<path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/>',
  };
</script>

<script lang="ts">
  let { name, size = 20 }: { name: IconName; size?: number } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
>
  {@html P[name]}
</svg>
